import { render, staticRenderFns } from "./BlacklistEmails.vue?vue&type=template&id=5489cf9f&scoped=true&"
import script from "./BlacklistEmails.vue?vue&type=script&lang=js&"
export * from "./BlacklistEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489cf9f",
  null
  
)

export default component.exports